import { Component, Input } from "@angular/core";
import { PagingTableComponent } from '../table-component/paging.table.component';

@Component({
    selector: "[xo-table-filter-row]",
    templateUrl: "./table-filter.component.html"
})
export class TableFilterComponent {
    @Input() parent: PagingTableComponent<any>;
}